import React, { useState, useEffect } from "react";
import { useStateContext } from "../../context/ContextProvider";
import { deadlines } from "./deadlines";
import { bgMap, borderMap } from "../ColorMappingOptions";

const ColorCountdown = ({
  color = "orange",
  addClass = ""
}) => {

  const [selectedDeadline, setSelectedDeadline] = useState("");
  const [timeRemaining, setTimeRemaining] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  // Find the next deadline
  useEffect(() => {
    const today = new Date();
    let nextDeadline = deadlines.find(
      (date) => new Date(date).getTime() > today.getTime()
    );

    if (!nextDeadline) {
      const fallbackDate = new Date(today.getTime() + 2 * 24 * 60 * 60 * 1000);
      nextDeadline = fallbackDate.toISOString();
    }

    setSelectedDeadline(new Date(nextDeadline));
  }, []);

  // Update countdown every second
  useEffect(() => {
    const calculateTimeRemaining = () => {
      if (!selectedDeadline) return;

      const total = new Date(selectedDeadline).getTime() - new Date().getTime();
      const days = Math.floor(total / (1000 * 60 * 60 * 24));
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((total / (1000 * 60)) % 60);
      const seconds = Math.floor((total / 1000) % 60);

      setTimeRemaining({ days, hours, minutes, seconds });

      if (total <= 0) {
        clearInterval(intervalId);
      }
    };

    const intervalId = setInterval(calculateTimeRemaining, 1000);
    return () => clearInterval(intervalId);
  }, [selectedDeadline]);

  return (
    <div
      className={`flex justify-center w-full`}
      style={{
        zIndex: 10,
      }}
    >
      <div className="countdown-overlay font-poppins font-light">
        <div className={`countdown-clock`}>
          <div className="clock">
            <div className={`clock__item ${bgMap[color]} ${borderMap[color]}`}>
              <span className="days">{timeRemaining.days}</span>
            </div>
            <div className="clock__colon">:</div>
            <div className={`clock__item ${bgMap[color]} ${borderMap[color]}`}>
              <span className="hours">{timeRemaining.hours}</span>
            </div>
            <div className="clock__colon">:</div>
            <div className={`clock__item ${bgMap[color]} ${borderMap[color]}`}>
              <span className="minutes">{timeRemaining.minutes}</span>
            </div>
            <div className="clock__colon">:</div>
            <div className={`clock__item ${bgMap[color]} ${borderMap[color]}`}>
              <span className="seconds">{timeRemaining.seconds}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorCountdown;
